// Shared request headers for the `/api/auth/*` endpoints.

// These endpoints speak plain JSON, not the gateway's JSON:API default
// (`application/vnd.api+json`) — send matching headers or the backend rejects
// the request ("Invalid value for header: content-type").
export const jsonHeaders = { headers: { Accept: 'application/json', 'Content-Type': 'application/json' } };

// Login-challenge endpoints authenticate with the pre-auth `mfa_token` (Bearer),
// NOT the session cookie — no session exists yet at that point in the login.
// TTL is 10 minutes; expired/invalid → 401.
export const mfaHeaders = (mfaToken: string) => ({
  headers: { ...jsonHeaders.headers, Authorization: `Bearer ${mfaToken}` },
});
